import { InjectionToken } from "@angular/core";

/**
 * @type {InjectionToken<SessionManagerServiceConfig>} Angular DI provider token for session manager configuration.
 */
export const SessionManagerServiceConfigToken: InjectionToken<SessionManagerServiceConfig> = new InjectionToken<SessionManagerServiceConfig>("core.session.manager.config");

/**
 * A type for session manager configuraiton elements.
 */
export interface SessionManagerServiceConfig {
    /**
     * The time in seconds that should pass after the last client side user action for the session manager to send a
     * session revive call to the backend.
     */
    reviveDelayInSec?: number;
}
